import { defineComponent as r, createBlock as n, openBlock as a, unref as p, mergeProps as s, withCtx as c, createElementVNode as m } from "vue";
import { RevIcon as f } from "@ds/components/Icon";
const d = /* @__PURE__ */ r({
  name: "IconRefresh",
  __name: "IconRefresh",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const o = t;
    return (l, e) => (a(), n(p(f), s(o, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        m("path", { d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75a.75.75 0 0 0-1.5 0 8.25 8.25 0 1 1-16.5 0 8.25 8.25 0 0 1 14.124-5.794l.042.044H16a.75.75 0 0 0 0 1.5h3a1.25 1.25 0 0 0 1.25-1.25V3a.75.75 0 0 0-1.5 0v1.964A9.72 9.72 0 0 0 12 2.25" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  d as default
};
